<style>
  .popover {
    background-color: #7B1FA2;
    color: #fff;
  }
  .popover>.arrow:after {
    border-top-color: #7B1FA2 !important;
  }
</style>

<button type="button" class="btn btn-success"
        popover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
  I was globally styled
</button>
